var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx } from 'theme-ui';
import Text from './Text';
/**
 *
 * @param {{
 * children: React.ReactNode;
 * variant?: import('./pVariants').PVariants
 * }} props
 * @returns
 */
export default function P(_a) {
    var { children, variant = 'default' } = _a, rest = __rest(_a, ["children", "variant"]);
    return (jsx(Text, Object.assign({ as: "p", 
        // @ts-ignore We pass in another set of variants, so this is ok.
        variant: variant, variants: "p" }, rest), children));
}
//# sourceMappingURL=P.js.map